export const TRAIL_CATALOG_GROUPS = [
  {
    id: "downhill",
    label: "Downhill",
    color: "#ff4d5a",
    description: "Gravity-first descents, race lines and freeride terrain.",
  },
  {
    id: "flow",
    label: "Flow",
    color: "#22c55e",
    description: "Shaped, smooth and playful lines built around rhythm.",
  },
  {
    id: "enduro",
    label: "Enduro / Technical",
    color: "#3b82f6",
    description: "Natural, technical and singletrack-focused riding.",
  },
  {
    id: "jump-skills",
    label: "Jump / Skills",
    color: "#f59e0b",
    description: "Jump lines, progression areas, pump and skills features.",
  },
  {
    id: "uphill",
    label: "Uphill",
    color: "#a78bfa",
    description: "Dedicated climbing and uphill access trails.",
  },
  {
    id: "connectors",
    label: "Connectors",
    color: "#a1a1aa",
    description: "Transfer and linking trails between riding zones.",
  },
  {
    id: "other",
    label: "Other",
    color: "#71717a",
    description: "Other published rideable lines in this destination.",
  },
];

const GROUP_BY_ID = Object.fromEntries(TRAIL_CATALOG_GROUPS.map((group) => [group.id, group]));

const normalize = (value) => String(value || "").trim().toLowerCase();

const containsAny = (values, candidates) => candidates.some((candidate) =>
  values.some((value) => value === candidate || value.includes(candidate)),
);

export const trailCatalogGroupId = (trail) => {
  const values = [normalize(trail?.trail_type), normalize(trail?.riding_style)].filter(Boolean);

  if (containsAny(values, ["uphill", "climb"])) return "uphill";
  if (containsAny(values, ["connector", "transfer", "link"])) return "connectors";
  if (containsAny(values, [
    "jump", "slopestyle", "pump", "pumptrack", "skills", "practice", "training",
    "4x", "4cross", "bikercross", "dual cross", "progression", "kids trail", "family",
  ])) return "jump-skills";
  if (containsAny(values, ["flow"])) return "flow";
  if (containsAny(values, ["enduro", "technical", "singletrack", "natural", "north shore"])) return "enduro";
  if (containsAny(values, ["downhill", "freeride", "race", "dh"])) return "downhill";

  return "other";
};

export const trailCatalogCounts = (trails = []) => {
  const counts = Object.fromEntries(TRAIL_CATALOG_GROUPS.map(({ id }) => [id, 0]));
  for (const trail of trails) counts[trailCatalogGroupId(trail)] += 1;
  return counts;
};

export const filterTrailsByCatalogGroup = (trails = [], groupId = "all") =>
  groupId === "all" ? trails : trails.filter((trail) => trailCatalogGroupId(trail) === groupId);

export const groupTrailsForCatalog = (trails = []) => {
  const grouped = new Map(TRAIL_CATALOG_GROUPS.map((group) => [group.id, []]));
  for (const trail of trails) grouped.get(trailCatalogGroupId(trail)).push(trail);

  return TRAIL_CATALOG_GROUPS
    .map((group) => ({ ...group, trails: grouped.get(group.id) }))
    .filter((group) => group.trails.length > 0);
};

export const trailCatalogGroupMeta = (groupId) => GROUP_BY_ID[groupId] ?? GROUP_BY_ID.other;
